<template>
<div class="chapter">
<div class="inner_page">
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9780715338865_epub_cov.vue?a06c8f40